/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_06_Detail_Beginner_0_HeadingInputs */

const en_method_content_step_06_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf should not hurt`)
};

const es_method_content_step_06_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El golf no debería doler`)
};

const de_method_content_step_06_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf sollte nicht wehtun`)
};

const zh_method_content_step_06_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打高尔夫不该疼`)
};

const ar_method_content_step_06_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الغولف لا ينبغي أن يؤلم`)
};

const fr_method_content_step_06_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le golf ne devrait pas faire de mal`)
};

const vi_method_content_step_06_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf không nên đau`)
};

const sw_method_content_step_06_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gofu haipaswi kuumiza`)
};

const th_method_content_step_06_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กอล์ฟไม่ควรทำให้เจ็บ`)
};

const bs_method_content_step_06_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf ne bi trebao boljeti`)
};

const ja_method_content_step_06_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゴルフは傷つけるべきではないです`)
};

const ko_method_content_step_06_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`골프 코스`)
};

const pt_method_content_step_06_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfe não deve machucar`)
};

const it_method_content_step_06_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf non dovrebbe far male`)
};

const sv_method_content_step_06_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf ska inte skada`)
};

const nl_method_content_step_06_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf mag geen pijn doen.`)
};

const da_method_content_step_06_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf skal ikke gøre ondt`)
};

const nb_method_content_step_06_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf bør ikke gjøre vondt`)
};

const fi_method_content_step_06_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf ei saa satuttaa`)
};

const pl_method_content_step_06_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf nie powinien boleć`)
};

const ru_method_content_step_06_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Гольф не повредит`)
};

const tr_method_content_step_06_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf acıtmamalı`)
};

const hi_method_content_step_06_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गोल्फ चोट नहीं होना चाहिए`)
};

const id_method_content_step_06_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf seharusnya tidak menyakitkan`)
};

const ms_method_content_step_06_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf tidak sepatutnya menyakitkan`)
};

const cs_method_content_step_06_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf by neměl ublížit.`)
};

const el_method_content_step_06_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Γκολφ δεν πρέπει να βλάψει`)
};

const he_method_content_step_06_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`גולף לא יפגע`)
};

const af_method_content_step_06_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gholf behoort nie seer te maak nie.`)
};

const hu_method_content_step_06_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A golf nem fájhat`)
};

/**
* | output |
* | --- |
* | "Golf should not hurt" |
*
* @param {Method_Content_Step_06_Detail_Beginner_0_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_06_detail_beginner_0_heading = /** @type {((inputs?: Method_Content_Step_06_Detail_Beginner_0_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_06_Detail_Beginner_0_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_06_detail_beginner_0_heading(inputs)
	if (locale === "de") return de_method_content_step_06_detail_beginner_0_heading(inputs)
	if (locale === "zh") return zh_method_content_step_06_detail_beginner_0_heading(inputs)
	if (locale === "ar") return ar_method_content_step_06_detail_beginner_0_heading(inputs)
	if (locale === "fr") return fr_method_content_step_06_detail_beginner_0_heading(inputs)
	if (locale === "vi") return vi_method_content_step_06_detail_beginner_0_heading(inputs)
	if (locale === "sw") return sw_method_content_step_06_detail_beginner_0_heading(inputs)
	if (locale === "th") return th_method_content_step_06_detail_beginner_0_heading(inputs)
	if (locale === "bs") return bs_method_content_step_06_detail_beginner_0_heading(inputs)
	if (locale === "ja") return ja_method_content_step_06_detail_beginner_0_heading(inputs)
	if (locale === "ko") return ko_method_content_step_06_detail_beginner_0_heading(inputs)
	if (locale === "pt") return pt_method_content_step_06_detail_beginner_0_heading(inputs)
	if (locale === "it") return it_method_content_step_06_detail_beginner_0_heading(inputs)
	if (locale === "sv") return sv_method_content_step_06_detail_beginner_0_heading(inputs)
	if (locale === "nl") return nl_method_content_step_06_detail_beginner_0_heading(inputs)
	if (locale === "da") return da_method_content_step_06_detail_beginner_0_heading(inputs)
	if (locale === "nb") return nb_method_content_step_06_detail_beginner_0_heading(inputs)
	if (locale === "fi") return fi_method_content_step_06_detail_beginner_0_heading(inputs)
	if (locale === "pl") return pl_method_content_step_06_detail_beginner_0_heading(inputs)
	if (locale === "ru") return ru_method_content_step_06_detail_beginner_0_heading(inputs)
	if (locale === "tr") return tr_method_content_step_06_detail_beginner_0_heading(inputs)
	if (locale === "hi") return hi_method_content_step_06_detail_beginner_0_heading(inputs)
	if (locale === "id") return id_method_content_step_06_detail_beginner_0_heading(inputs)
	if (locale === "ms") return ms_method_content_step_06_detail_beginner_0_heading(inputs)
	if (locale === "cs") return cs_method_content_step_06_detail_beginner_0_heading(inputs)
	if (locale === "el") return el_method_content_step_06_detail_beginner_0_heading(inputs)
	if (locale === "he") return he_method_content_step_06_detail_beginner_0_heading(inputs)
	if (locale === "af") return af_method_content_step_06_detail_beginner_0_heading(inputs)
	if (locale === "hu") return hu_method_content_step_06_detail_beginner_0_heading(inputs)
	return en_method_content_step_06_detail_beginner_0_heading(inputs)
});